import {
    Domain,
} from 'app/requests/ValueMapping/ValueMapping.types'
import {
    ForecastCreateRawData,
} from './ShortTermForecastCsvUpload.types'

export const mandatoryHeaders: Extract<keyof ForecastCreateRawData, string>[] = [
    'validAsOf',
    'accountName',
    'originAirport',
    'destinationAirport',
    'productType',
    'leaseType',
]

export const propertiesToDomainMap: Record<keyof ForecastCreateRawData, Domain> = {
    accountName: Domain.ACCOUNT,
    originAirport: Domain.AIRPORT,
    destinationAirport: Domain.AIRPORT,
}
